"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostmarkBounceTypes = void 0;
const postmark_bounce_responses_enum_1 = require("./postmark-bounce-responses.enum");
exports.PostmarkBounceTypes = {
    1: postmark_bounce_responses_enum_1.PostmarkBounceResponses.HardBounce,
    100006: postmark_bounce_responses_enum_1.PostmarkBounceResponses.ISP,
};
